import type { ReactNode } from 'react'

export function Card({
  children,
  className = '',
  padat = false,
}: {
  children: ReactNode
  className?: string
  padat?: boolean
}) {
  return (
    <section
      className={`rounded-xl border border-netral-200 bg-white shadow-sm ${padat ? '' : 'p-4 sm:p-5'} ${className}`}
    >
      {children}
    </section>
  )
}

export function CardHeader({
  judul,
  deskripsi,
  aksi,
  className = '',
}: {
  judul: ReactNode
  deskripsi?: ReactNode
  aksi?: ReactNode
  className?: string
}) {
  return (
    <div className={`flex flex-wrap items-start justify-between gap-3 ${className}`}>
      <div className="min-w-0">
        <h2 className="text-base font-semibold text-netral-900">{judul}</h2>
        {deskripsi ? <p className="mt-0.5 text-sm text-netral-500">{deskripsi}</p> : null}
      </div>
      {aksi ? <div className="flex flex-wrap items-center gap-2">{aksi}</div> : null}
    </div>
  )
}

/** Grid kartu indikator. */
export function GridKartu({ children, kolom = 4 }: { children: ReactNode; kolom?: 2 | 3 | 4 }) {
  const kelas = kolom === 2 ? 'sm:grid-cols-2' : kolom === 3 ? 'sm:grid-cols-2 lg:grid-cols-3' : 'sm:grid-cols-2 lg:grid-cols-4'
  return <div className={`grid grid-cols-1 gap-4 ${kelas}`}>{children}</div>
}
